import { useMemo } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Grid, ContactShadows } from '@react-three/drei';
import { editorStore } from '../../stores/editorStore';
import { EditorElement as ElementMesh } from './EditorElement';
import { EditorTextBox } from './EditorTextBox';
import { EditorLighting } from './EditorLighting';

/**
 * 画布区 R3F 实时预览
 * 桌面尺寸的虚拟舞台，元素与文本在同一 3D 空间
 */
export function CanvasPreview() {
  const page = editorStore((s) =>
    s.book?.pages.find((p) => p.id === s.currentPageId) ?? null
  );
  const selectedId = editorStore((s) => s.selectedElementId);
  const setSelected = editorStore((s) => s.setSelectedElement);

  const background = useMemo(
    () => (page ? page.background.color : '#1a2340'),
    [page]
  );

  return (
    <Canvas
      key={page?.id ?? 'empty'}
      camera={{ position: [0, 1.5, 6.5], fov: 50 }}
      dpr={[1, 2]}
      style={{ background }}
      gl={{ antialias: true, alpha: false }}
    >
      {page && (
        <>
          <EditorLighting
            preset={page.lighting.preset}
            intensity={page.lighting.intensity}
            fog={page.lighting.fog}
            background={background}
          />

          <Grid
            position={[0, -2.6, 0]}
            args={[12, 12]}
            cellSize={0.5}
            cellThickness={0.6}
            cellColor="#4a5578"
            sectionSize={2.5}
            sectionThickness={1.2}
            sectionColor="#6a7aa8"
            fadeDistance={14}
            fadeStrength={1}
            infiniteGrid
          />
          <ContactShadows
            position={[0, -2.59, 0]}
            opacity={0.35}
            scale={10}
            blur={2.2}
            far={4}
            color="#000015"
          />

          {page.elements.map((el) => (
            <ElementMesh
              key={el.id}
              element={el}
              selected={el.id === selectedId}
              onSelect={() => setSelected(el.id)}
            />
          ))}

          {page.texts.map((text) => (
            <EditorTextBox key={text.id} storyText={text} />
          ))}

          <OrbitControls
            makeDefault
            target={[0, 0, 0]}
            minDistance={2}
            maxDistance={14}
            maxPolarAngle={Math.PI / 2.1}
            enablePan
          />
        </>
      )}
    </Canvas>
  );
}